export default "<p>\n  payments-adapter works! </p>\n"